var _a;
import { __decorate, __metadata, __param } from "tslib";
// import { inject, injectable } from '@patsnap/tahiti-core';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ExportRepository } from '../repositories/export-repository.interface';
let ExportServiceImpl = class ExportServiceImpl {
    constructor(_exportRepository) {
        this._exportRepository = _exportRepository;
    }
    getExportQueryId(params) {
        return this._exportRepository.getExportQueryId(params);
    }
};
ExportServiceImpl = __decorate([
    injectable(),
    __param(0, inject(ExportRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof ExportRepository !== "undefined" && ExportRepository) === "function" ? _a : Object])
], ExportServiceImpl);
export { ExportServiceImpl };
